import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import type { CarState } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = { id: number };
type Response = CarState;

export const useCarStateRefresh = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id }) =>
    client({
      url: `v2/internal/partners/cars/${id}/state/refresh`,
      method: 'POST',
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
